import { render, staticRenderFns } from "./Asilage.vue?vue&type=template&id=40dd365b"
import script from "./Asilage.vue?vue&type=script&lang=js"
export * from "./Asilage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports